export enum ErrorTypes {
  DUPLICATE_KEY = 'E11000 duplicate key error collection',
  EXIST_REGISTER = 'already exist',
  MODEL_STATE = 'modelstatevalidation',
  REQUEST_DRIVER = 'request.Driver',
  DOB_INVALID = 'DOB is not valid',
  HOTEL_BOOK_ERROR = 'hotelbookerror',
  HOTEL_BOOK_ERROR_BY_CHILD_DATE = 'Hotel Book Error - The child\'s date of birth does not match',
  PACKAGE_BOOK_ERROR = 'PackageBookFailed',
  PACKAGE_BOOK_ERROR_BY_CHILD_DATE = 'PackageBook Failed -The child\'s date of birth does not match',
}
